// Shared by the template list and the editor

export const STATUSES = {
  draft: {
    label: "Ноорог",
    badge: "text-gray-700 bg-gray-100 dark:text-gray-100 dark:bg-gray-700",
  },
  published: {
    label: "Нийтлэгдсэн",
    badge: "text-green-700 bg-green-100 dark:bg-green-700 dark:text-green-100",
  },
  archived: {
    label: "Архив",
    badge: "text-yellow-700 bg-yellow-100 dark:bg-yellow-700 dark:text-yellow-100",
  },
};

// The categories the starter templates use, with their icons as on cloudprint.mn
// (client/src/components/template/categoryIcon.js in the backend repo). The category
// is typed freely, so an unknown one gets the plain document icon.
export const CATEGORY_ICONS = {
  Сургууль: "fa-graduation-cap",
  Ажил: "fa-briefcase",
  "Хувь хүн": "fa-user",
  Зар: "fa-bullhorn",
  Гэрээ: "fa-file-contract",
  Байгууллага: "fa-building",
  Бизнес: "fa-store",
  Урилга: "fa-envelope-open-text",
  Мэндчилгээ: "fa-gift",
};
export const categoryIcon = (category) => CATEGORY_ICONS[category] || "fa-file-alt";
// What a template without a category is listed under
export const NO_CATEGORY = "Ангилалгүй";

export const FIELD_TYPES = [
  { value: "text", label: "Текст" },
  { value: "textarea", label: "Олон мөр" },
  { value: "date", label: "Огноо" },
  { value: "select", label: "Сонголт" },
  { value: "tel", label: "Утас" },
  { value: "number", label: "Тоо" },
  { value: "rows", label: "Мөрүүд (хүснэгт)" },
];

// What a column of a rows field can be (models/Template.js on the backend)
export const COLUMN_TYPES = [
  { value: "text", label: "Текст" },
  { value: "number", label: "Тоо" },
  { value: "select", label: "Сонголт" },
  { value: "date", label: "Огноо" },
];

// The A4 page of the PDF (utils/templatePdf.js on the backend)
export const ORIENTATIONS = [
  { value: "portrait", label: "Босоо" },
  { value: "landscape", label: "Хэвтээ" },
];
export const MARGINS = [
  { value: "official", label: "Албан бичиг: зүүн 30, баруун 15, дээд доод 20 мм" },
  { value: "even", label: "Тэгш: бүх талаас 20 мм" },
  { value: "narrow", label: "Нарийн: бүх талаас 10 мм" },
];

export const money = (value) =>
  value === null || value === undefined ? "—" : Number(value).toLocaleString() + "₮";

export const fieldClass =
  "block w-full h-10 px-3 text-sm text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:border-purple-400 focus:ring focus:ring-purple-200 focus:ring-opacity-50 focus:outline-none dark:focus:ring-gray-500";
export const areaClass =
  "block w-full px-3 py-2 text-sm text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:border-purple-400 focus:ring focus:ring-purple-200 focus:ring-opacity-50 focus:outline-none dark:focus:ring-gray-500";
export const labelClass =
  "block mb-1 text-xs font-medium tracking-wide text-gray-500 uppercase dark:text-gray-400";
export const primaryButton =
  "px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-200";
export const secondaryButton =
  "px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition-colors duration-150 bg-white border border-gray-300 rounded-lg dark:text-gray-300 dark:bg-gray-700 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-200";
export const smallButton =
  "px-3 py-1 text-xs font-medium leading-5 text-gray-700 transition-colors duration-150 bg-white border border-gray-300 rounded-lg dark:text-gray-300 dark:bg-gray-700 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 focus:outline-none";
